(() => {
  let pending = false;
  function placeQuoteButtons() {
    pending = false;
    document.querySelectorAll('[data-hl-quote-slot]').forEach(slot => {
      const id = slot.dataset.productId;
      const buttons = Array.from(document.querySelectorAll('.rfq-btn[data-product-id]'));
      const button = buttons.find(el => el.dataset.productId === id && !el.classList.contains('rfq-collection-btn'));
      if (!button || slot.contains(button)) return;
      slot.append(button);
    });
  }
  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(placeQuoteButtons);
  }
  placeQuoteButtons();
  new MutationObserver(schedule).observe(document.body, {childList:true,subtree:true});
  document.addEventListener('shopify:section:load', schedule);
})();